const checkFirstPageLoad = (page) => {
  const openPage = page.pathname + page.hash

  if (page.hash === '#planner') {
    localStorage.setItem('openPage', openPage)
  }
}

export { checkFirstPageLoad }
